import React, { useEffect, useState } from "react";
import { Stack, Card, Typography, FormControlLabel } from "@mui/material";
import ColorSelector from "./ColorSelector";
import Dropdown from "./Dropdown";
import DropdownWithoutLabel from "./DropdownWithoutLabel";
import { useAuth } from "../../context/API_Client";

const Branding = ({ theme, updateTheme }) => {
  return (
    <Stack spacing={2} sx={{ padding: "0 20px 0 20px" }}>
      <Card
        variant="outlined"
        sx={{
          minWidth: 268,
          minHeight: 68,
          alignItems: "center",
          border: "none",
          borderBottom: "1px solid #DFDFDF",
          padding: "0 10px 0 10px",
        }}
      >
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: "400",
            color: "#010102",
            opacity: "0.92",
            lineHeight: "18px",
          }}
        >
          Branding Options
        </Typography>
        <Typography
          sx={{
            fontSize: "12px",
            fontWeight: "400",
            color: "#010102",
            opacity: "0.72",
            lineHeight: "20px",
          }}
        >
          Customise the checkout experience according to your business needs
        </Typography>
      </Card>

      <Card
        variant="outlined"
        sx={{
          minWidth: 268,
          height: 324,
          alignItems: "center",
          border: "none",
          padding: "10px",
          borderBottom: "1px solid #DFDFDF",
        }}
      >
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: "400",
            color: "#010102",
            opacity: "0.6",
            lineHeight: "18px",
          }}
        >
          Choose brand colours
        </Typography>

        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          paddingTop="30px"
        >
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: "400",
              color: "#010102",
              opacity: "0.92",
              lineHeight: "18px",
            }}
          >
            Header
          </Typography>

          <ColorSelector
            theme={theme}
            updateTheme={updateTheme}
            dropDownId={"headerColor"}
          />
        </Stack>

        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          paddingTop="30px"
        >
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: "400",
              color: "#010102",
              opacity: "0.92",
              lineHeight: "18px",
            }}
          >
            Header Text
          </Typography>

          <ColorSelector
            theme={theme}
            updateTheme={updateTheme}
            dropDownId={"headerTextColor"}
          />
        </Stack>

        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          paddingTop="30px"
        >
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: "400",
              color: "#010102",
              opacity: "0.92",
              lineHeight: "18px",
            }}
          >
            Pay Button
          </Typography>
          <ColorSelector
            theme={theme}
            updateTheme={updateTheme}
            dropDownId={"primaryButtonColor"}
          />
        </Stack>

        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          paddingTop="30px"
        >
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: "400",
              color: "#010102",
              opacity: "0.92",
              lineHeight: "18px",
            }}
          >
            Pay Button Text
          </Typography>

          <ColorSelector
            theme={theme}
            updateTheme={updateTheme}
            dropDownId={"buttonTextColor"}
          />
        </Stack>
      </Card>

      <Card
        variant="outlined"
        sx={{
          minWidth: 268,
          height: 124,
          alignItems: "center",
          border: "none",
          padding: "10px",
          borderBottom: "1px solid #DFDFDF",
        }}
      >
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: "400",
            color: "#010102",
            opacity: "0.6",
            lineHeight: "18px",
          }}
        >
          Typography
        </Typography>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          paddingTop="30px"
        >
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: "400",
              color: "#010102",
              opacity: "0.92",
              lineHeight: "18px",
            }}
          >
            Font
          </Typography>
          {theme.font != undefined ? (
            <Dropdown
              width={168}
              options={["Poppins", "Arial"]}
              theme={theme}
              updateTheme={updateTheme}
              dropDownId={"font"}
              def={theme.font}
            />
          ) : (
            <></>
          )}
        </Stack>
      </Card>

      <Card
        variant="outlined"
        sx={{
          minWidth: 268,
          alignItems: "center",
          border: "none",
          padding: "10px",
          paddingBottom: "20px"
        }}
      >
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: "400",
            color: "#010102",
            opacity: "0.60",
            lineHeight: "18px",
          }}
        >
          More options
        </Typography>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          paddingTop="30px"

        >
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: "400",
              color: "#010102",
              opacity: "0.92",
              lineHeight: "18px",
            }}
          >
            Button Shape
          </Typography>
          {theme.buttonShape != undefined ? (
            <Dropdown
              width={120}
              options={["RECTANGLE", "ROUNDED"]}
              theme={theme}
              updateTheme={updateTheme}
              dropDownId={"buttonShape"}
              def={theme.buttonShape}
            />
          ) : (
            <></>
          )}
        </Stack>
      </Card>
    </Stack>
  );
};

export default Branding;
